import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAzureOpenai = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 24,
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#a)",
			d: "M9.21 1.636h6.51L8.961 21.658a1.038 1.038 0 0 1-.984.706H2.912a1.035 1.035 0 0 1-.982-1.368L8.226 2.342a1.038 1.038 0 0 1 .984-.706Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0078D4",
			d: "M18.669 15.065H8.346a.477.477 0 0 0-.326.828l6.633 6.19c.193.18.448.281.712.28h5.845l-2.541-7.298Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#b)",
			d: "M9.21 1.636a1.03 1.03 0 0 0-.987.72L1.938 20.979a1.035 1.035 0 0 0 .977 1.384h5.197a1.11 1.11 0 0 0 .852-.724l1.253-3.695 4.478 4.177c.188.155.423.24.666.242h5.824l-2.554-7.298-7.446.002 4.557-13.431H9.21Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#c)",
			d: "M17.524 2.34a1.037 1.037 0 0 0-.982-.704H9.287a1.036 1.036 0 0 1 .982.705l6.296 18.655a1.037 1.037 0 0 1-.982 1.368h7.255a1.035 1.035 0 0 0 .982-1.368L17.524 2.34Z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "a",
				x1: 11.582,
				x2: 4.822,
				y1: 3.172,
				y2: 23.143,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#114A8B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0669BC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "b",
				x1: 13.694,
				x2: 12.13,
				y1: 12.479,
				y2: 13.008,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopOpacity: .3 }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .071,
						stopOpacity: .2
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .321,
						stopOpacity: .1
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .623,
						stopOpacity: .05
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "c",
				x1: 12.834,
				x2: 20.255,
				y1: 2.589,
				y2: 22.36,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3CCBF4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#2892DF"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAzureOpenai);
export { ForwardRef as ReactComponent };
